import PhongHocSinh from "./PhongHocSinh";

export default PhongHocSinh